import { forwardRef } from "react";
import { PlusIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const NEUTRAL_CLASS =
  "h-8 w-8 shrink-0 rounded-full border border-dashed border-slate-200 bg-slate-50/60 p-0 text-slate-400 hover:border-slate-300 hover:bg-slate-100 hover:text-slate-500";

const WARNING_CLASS =
  "h-8 w-8 shrink-0 rounded-full border border-dashed border-[#E67E22]/35 bg-[#E67E22]/10 p-0 text-[#A85818]/70 hover:border-[#E67E22]/60 hover:bg-[#E67E22]/20 hover:text-[#A85818]";

// Reusable empty-state trigger button for table cells.
// neutral: gray dotted circle + PlusIcon — "unset, click to set here"
// warning: amber dotted circle + TriangleAlertIcon — "unset, action required"
// Supports asChild so it can wrap a Link or act as a DropdownMenuTrigger child.
export const EmptyCellButton = forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof Button> & {
    state?: "neutral" | "warning";
  }
>(({ state = "neutral", asChild, children, className, ...props }, ref) => (
  <Button
    ref={ref}
    type="button"
    variant="ghost"
    asChild={asChild}
    {...props}
    className={cn(
      state === "warning" ? WARNING_CLASS : NEUTRAL_CLASS,
      className,
    )}
  >
    {asChild ? (
      children
    ) : (
      <PlusIcon className="h-3.5 w-3.5 shrink-0 opacity-70" aria-hidden />
    )}
  </Button>
));

EmptyCellButton.displayName = "EmptyCellButton";
